<template>
  <navbar>
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;</button>
    <a class="navbar-brand" href="#"><span class="hidden-md-down"></span></a>
    <ul class="nav navbar-nav d-md-down-none">
      <li class="nav-item">
        <a class="nav-link navbar-toggler sidebar-toggler" href="#" @click="sidebarMinimize">&#9776;</a>
      </li>
      <li class="nav-item px-3" v-if="$session.user && $session.user.admin">
        <router-link :to="'/users'" class="nav-link" exact>Users</router-link>
      </li>
      <li class="nav-item px-3" v-if="$session.user && $session.user.admin">
        <router-link :to="'/machines'" class="nav-link" exact>Machines</router-link>
      </li>
    </ul>
    <ul class="nav navbar-nav ml-auto">
      <!--
      <li class="nav-item d-md-down-none">
        <a class="nav-link" href="#"><i class="icon-bell"></i><span class="badge badge-pill badge-danger">5</span></a>
      </li>
      <li class="nav-item d-md-down-none">
        <a class="nav-link" href="#"><i class="icon-list"></i></a>
      </li>
      <li class="nav-item d-md-down-none">
        <a class="nav-link" href="#"><i class="icon-location-pin"></i></a>
      </li>
      -->
      <dropdown size="nav" class="nav-item">
        <span slot="button">
          <!--<img src="static/img/avatar.jpg" class="img-avatar" :alt="$session.user && $session.user.email">-->
          <span class="d-md-down-none">{{$session.user.firstname}} {{$session.user.lastname}}</span>
        </span>
        <div slot="dropdown-menu" class="dropdown-menu dropdown-menu-right">

          <div class="dropdown-header text-center"><strong>Account</strong></div>

          <router-link class="dropdown-item" :to="'/profile'" href="#"><i class="fa fa-user"></i> Profile</router-link>
          <a class="dropdown-item" @click="$session.logout"><i class="fa fa-lock"></i> Logout</a>
        </div>
      </dropdown>
      <li class="nav-item d-md-down-none">

      </li>
    </ul>
  </navbar>
</template>

<style lang="scss">
.app-header.navbar .navbar-brand {
  background-size: 140px auto;
  background-position: center right;
}
</style>

<script>

import navbar from './Navbar'
import { dropdown } from 'vue-strap'

export default {
  name: 'header',
  components: {
    navbar,
    dropdown
  },
  methods: {
    click () {
      // do nothing
    },
    sidebarToggle (e) {
      e.preventDefault()
      setTimeout(() => {
        this.$session.$emit('resize')
      }, 200)
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      setTimeout(() => {
        this.$session.$emit('resize')
      }, 200)
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      this.$session.$emit('resize')
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      this.$session.$emit('resize')
      document.body.classList.toggle('aside-menu-hidden')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Header.vue?1865d0a0